export default "__VITE_ASSET__BYLUgKuh__"